export default "__VITE_ASSET__CIxWWFVV__"